import crud from "./crud";
import crud_service from "@/services/crud";

const path = "hourly_productions";
const struct = {
  price: "",
  region: "FR",
  date: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,
};

const actions = {
  ...generic.actions,

  getCurrent({ commit }, params) {
    const query = {};
    if (params && params.month) query.month = params.month;
    if (params && params.year) query.year = params.year;

    return new Promise((resolve) => {
      crud_service.fetch(`${path}/current`, query).then((item) => {
        commit("setItems", [item]);
        resolve(item);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

